export default __webpack_public_path__ + "static/media/advisor-dl.9e039750.jpg";